import { ECollaboratorInviteRole, ECollaboratorInviteStatus } from '@lifk/types';
import { z } from 'zod';
import { UUIDValidationSchema } from './uuid';
const EmailsListSchema = z
    .array(z.string().email())
    .max(25, { message: 'You can invite up to 25 people at a time.' });
const CollaboratorInviteValidationSchema = z.object({
    workshopId: UUIDValidationSchema,
    emails: EmailsListSchema,
    role: z.nativeEnum(ECollaboratorInviteRole)
});
const UpdateCollaboratorInviteValidationSchema = z.object({
    id: UUIDValidationSchema,
    invalidated: z.boolean(),
    status: z.nativeEnum(ECollaboratorInviteStatus).optional(),
    role: z.nativeEnum(ECollaboratorInviteRole).optional()
});
const ResendCollaboratorInviteValidationSchema = z.object({
    id: UUIDValidationSchema
});
export { CollaboratorInviteValidationSchema, EmailsListSchema, ResendCollaboratorInviteValidationSchema, UpdateCollaboratorInviteValidationSchema };
//# sourceMappingURL=collaboratorInvite.js.map